import { LoaderFullscreen } from "modules/core/components";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Redirect = () => {
  const navigate = useNavigate();

  navigate("/home");

  return (
    <div>
      <LoaderFullscreen />;
    </div>
  );
};
